export default {
  classSection: {
    id: '',
    courseOutline: null,
    courseOutlineRegistration: null,
    sectionNo: null,
    descriptionLocal: '',
    descriptionEng: '',
    studentRegisterQty: null,
    studentQty: null,
    vdoSet: null,
    vdoSetCode: '',
    startClassDate: null,
    learnSpanNo: null,
    examSpanNo: null,
    classMaterials: [],
    classAssignments: [],
    classRoom: null
  },
  classSections: [],
  processing: false,
  error: null,
  success: null,
}



